import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  ListItemText,
  List,
  Grid,
  Box,
  Typography,
  Paper,
  Backdrop,
  CircularProgress,
  ListItem,
  IconButton,
  Snackbar,
  Button,
  AppBar,
  Stack,
  Alert,
} from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import axiosBaseURL from "../../../utilities/httpCommon";
import Confirmdialog from "./Confirmdialog";
import DeleteIcon from "@mui/icons-material/Delete";
import { Inserttablecells } from "../../../utilities/Wordutil";
import { TreeItem, TreeView } from "@mui/lab";
import CloseIcon from "@mui/icons-material/Close";
import OfficeAddinMessageBar from "./OfficeAddinMessageBar";
//import process = require("process");

/* global console  */
//axios.defaults.baseURL = process.env.REACT_APP_API_KEY;

const Inserttable = () => {
  const defaultobj = [{ name: "Agreement__c", list: [] }];
  const [mainlst, setmainlst] = useState(defaultobj);
  const [isprogress, setprogress] = useState(false);
  const [selmainnodeid, setselmainnodeid] = useState("");
  //const [open, setopen] = useState(false);
  const [mntreeviewdata, setmntreeviewdata] = useState([]);
  const [isloading, setisloading] = useState(false);
  const [selmainobj, setSelmainobj] = useState("");
  const [opendlg, setOpendlg] = React.useState(false);
  const [value, setValue] = React.useState({ id: "", label: "", name: "", results: false, subfields: [], type: "" });
  //const [selectedIndex, setSelectedIndex] = React.useState(0);
  //const [subselectedIndex, setsubSelectedIndex] = React.useState(-1);
  const [allobjects, setallobjects] = useState([]);
  const [columslist, setcolumslist] = useState([]);
  const [popupopen, setpopupopen] = React.useState(false);
  const [messagecaption, setmessagecaption] = useState("");
  const [errMsgd, seterrMsgd] = useState("");

  const history = useHistory();

  const handleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setpopupopen(false);
  };

  const errorDismissed = () => {
    seterrMsgd("");
  };

  const handleClosedlg = (newValue?: any) => {
    setOpendlg(false);
    if (newValue != null) {
      newValue.reverse();
      setValue(newValue[0]);
      if (columslist.length == 0) {
        let colslst = [];
        newValue.forEach((value: any) => {
          colslst.push({
            id: value.id,
            label: value.label,
            name: value.name,
            results: value.results,
            relationshipname: value.relationshipname,
            subfields: value.subfields,
            type: value.type,
          });
        });
        setcolumslist(colslst);
      } else {
        addcolumnlist(newValue);
      }
    }
  };

  const handleRemoveItem = (value) => {
    setcolumslist(columslist.filter((item) => item.name !== value));
  };

  async function ShowDlgforAddfields() {
    console.log(selmainobj);
    if (selmainobj === "Agreement__c") {
      setmessagecaption("Select any one of the related list");
      setpopupopen(true);
      return;
    }
    setOpendlg(true);
  }

  async function InserttablewithCC() {
    console.log("Table insert begins");
    console.log(selmainobj);
    //console.log(GetLabelfromAll(allobjects, selmainobj));
    let selmainndlabel = "";
    let objfind = GetLabelfromAll(allobjects, selmainobj);
    if (objfind != null) {
      selmainndlabel = objfind;
    }
    console.log(selmainndlabel + "==>");
    await Inserttablecells(columslist, selmainnodeid, selmainndlabel);
    history.push("/");
  }

  useEffect(() => {
    SetInitialData();
  }, []);

  function GetLabelfromAll(resallobjs, sobjname) {
    let findobj = resallobjs.find((x) => x.name === sobjname);
    console.log(findobj);
    if (findobj != null) {
      return findobj.label;
    } else {
      return sobjname;
    }
  }

  async function SetInitialData() {
    const obj = [{ name: "Agreement__c", list: [] }];
    setprogress(true);
    let result = await fetchData(obj[0].name, true);
    let resultall = await fetchData("globalall", true);
    console.log(resultall);
    setallobjects(resultall);
    setprogress(false);
    if (result != null) {
      let arrrefs = [];
      let mainrefs = [];
      result.forEach((element) => {
        if (element.relationshipName != null && element.relationshipName.includes("__r")) {
          arrrefs.push({
            id: obj[0].name + "." + element.childSObject,
            label: GetLabelfromAll(resultall, element.childSObject),
            name: element.childSObject,
            children: [],
          });
        }
      });
      mainrefs.push({
        label: GetLabelfromAll(resultall, obj[0].name),
        id: obj[0].name,
        name: obj[0].name,
        children: arrrefs,
      });
      setmntreeviewdata(mainrefs);
    }
    setmainlst(obj);
    let mainid = mainlst[0].name;
    console.log("sel mainid: " + mainid);
    console.log(mainid);
    setSelmainobj(mainid);
  }

  const fetchData = async (name: string, childrelation: boolean) => {
    try {
      setisloading(true);
      const res = await axiosBaseURL
        .get("/sfserver/getmetadata?object=" + name, {
          withCredentials: true,
        })
        .catch((error) => {
          setisloading(false);
          if (error.response) {
            seterrMsgd(error.response.data);
          } else if (error.request) {
            seterrMsgd(error.request);
          } else {
            seterrMsgd(error.message);
          }
        });
      setisloading(false);
      if (res.data != null) {
        if (name === "globalall") return res.data.sobjects;
        if (!childrelation) return res.data.fields;
        else if (childrelation) return res.data.childRelationships;
      } else return null;
    } catch (err) {
      setisloading(false);
    }
  };

  const addcolumnlist = (values: any) => {
    setcolumslist([...columslist, ...values]);
  };

  const treestyle = {
    "& .MuiTreeItem-label": {
      fontSize: "15px",
      padding: 0.25,
    },
  };

  const renderTree = (node: any) => (
    <TreeItem
      sx={treestyle}
      key={node.name}
      nodeId={node.id}
      label={node.relationshipName != null && node.relationshipName.includes("__r") ? node.label + "..." : node.label}
    >
      {Array.isArray(node.children) && node.children.length
        ? node.children.map((subnode: any) => renderTree(subnode))
        : null}
    </TreeItem>
  );

  // const onClick = async (id: string) => {
  //   console.log("Sel Object: " + id);
  //   setSelmainobj(id);
  // };
  let findValue = (arr, val) => {
    for (let obj of arr) {
      if (obj.id === val) {
        return obj;
      }
      if (obj.children) {
        let result = findValue(obj.children, val);
        if (result) {
          return result;
        }
      }
    }
    return undefined;
  };

  const handleNodeSelect = async (_: any, nodeId: any) => {
    let selfldvalue = findValue(mntreeviewdata, nodeId);
    if (selfldvalue != undefined && selfldvalue.name != defaultobj[0].name) {
      setSelmainobj(selfldvalue.name);
      console.log("Right selection => " + nodeId);
      setselmainnodeid(nodeId);
      if (!selfldvalue.results) {
        let result = await fetchData(selfldvalue.name, true);
        if (result != null) {
          let objfld = [];
          for (var node of result) {
            if (node.relationshipName != null && node.relationshipName.includes("__r")) {
              objfld.push({
                id: nodeId + "." + node.childSObject,
                name: node.childSObject,
                label: GetLabelfromAll(allobjects, node.childSObject),
                children: [],
                results: false,
              });
            }
          }
          const newState = [...mntreeviewdata];
          const newnode = findValue(newState, nodeId);
          if (newnode != undefined && objfld.length > 0) {
            newnode.children = objfld;
            newnode.results = true;
          } else {
            newnode.results = true;
          }
          setmntreeviewdata(newState);
        }
      }
    }
  };

  return (
    <Box sx={{ p: 1, marginTop: 0, marginLeft: 0, marginRight: 0 }}>
      {errMsgd.length > 0 ? <OfficeAddinMessageBar onDismiss={errorDismissed} message={errMsgd + " "} /> : null}
      <Grid container>
        <Grid item xs={12}>
          <Paper elevation={0} sx={{ border: 1, borderColor: "lightgray", maxHeight: 120, overflow: "auto" }}>
            {isprogress ? (
              <Typography>Loading please wait ... </Typography>
            ) : (
              <TreeView
                aria-label="rich object"
                defaultCollapseIcon={<ExpandMore />}
                defaultExpanded={[defaultobj[0].name]}
                defaultExpandIcon={<ChevronRightIcon />}
                onNodeSelect={handleNodeSelect}
                sx={{
                  margintop: 0,
                  position: "relative",
                  height: "100vh",
                  flexGrow: 1,
                  maxWidth: 500,
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                {mntreeviewdata.map((node) => renderTree(node))}
              </TreeView>
            )}
          </Paper>
        </Grid>
        <Grid item sx={{ marginTop: 2 }}>
          <Button
            variant="contained"
            sx={{ bgcolor: "#1C39BB", textTransform: "none" }}
            size="small"
            onClick={ShowDlgforAddfields}
          >
            <Typography sx={{ fontSize: 14 }}>Add Fields</Typography>
          </Button>
        </Grid>
        {columslist.length === 0 && (
          <Grid item xs={12} sx={{ marginTop: 2 }}>
            <Typography variant="body1">Select object from the list and add fields...</Typography>
          </Grid>
        )}
        <Grid item xs={12}>
          <List
            dense
            sx={{
              width: "100%",
              position: "relative",
              overflow: "auto",
              marginBottom: 2,
              marginTop: 2,
            }}
          >
            {columslist.map((item, index) => (
              <ListItem
                sx={{ margin: "0 px", padding: "0 px" }}
                divider
                disablePadding={true}
                key={index}
                secondaryAction={
                  <IconButton edge="end" aria-label="delete" onClick={() => handleRemoveItem(item.name)}>
                    <DeleteIcon sx={{ width: 19, height: 19 }} />
                  </IconButton>
                }
              >
                <ListItemText
                  primary={
                    <Typography
                      sx={{
                        display: "inline",
                        fontSize: 14,
                        "& .MuiTypography-caption": {
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        },
                      }}
                      component="span"
                      variant="caption"
                      color="#1C39BB"
                    >
                      {(index + 1).toString() + ". " + item.label}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>
        </Grid>
        <Grid item>
          <Snackbar open={popupopen} onClose={handleClose}>
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    handleClose();
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              severity="success"
              sx={{ width: "100%" }}
            >
              {messagecaption}
            </Alert>
          </Snackbar>
        </Grid>
      </Grid>
      <Confirmdialog
        keepMounted
        id="selflddlg"
        open={opendlg}
        onClose={handleClosedlg}
        value={value}
        tablemode={true}
        tablecondition={false}
        mainfldid={selmainobj}
      />
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isloading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <AppBar position="fixed" sx={{ top: "auto", bottom: 0 }}>
        <Stack direction="row" spacing={2}>
          <Button
            variant="contained"
            size="small"
            onClick={InserttablewithCC}
            sx={{ width: "100%", bgcolor: "#1C39BB" }}
          >
            <Typography>Insert</Typography>
          </Button>
        </Stack>
      </AppBar>
    </Box>
  );
};

export default Inserttable;
